import React from "react";
import { useParams } from "react-router-dom";

import { CloudFileDashboardContext, VersionInfo } from "./CloudFileDashboardContext";

export const CloudFileDashboardProvider: React.FC = ({ children }) => {
    const { cloudFileId } = useParams<{ cloudFileId: string }>();

    const [selectedVersionInfo, setSelectedVersionInfo] = React.useState<VersionInfo>();
    const [lookupFileRecordId, setLookupFileRecordId] = React.useState<string>();
    const [areUnsavedChanges, setAreUnsavedChanges] = React.useState<boolean>(false);
    const [isInactiveContentSelected, setIsInactiveContentSelected] = React.useState<boolean>(false);
    const [isAssociateFormReady, setIsAssociateFormReady] = React.useState<boolean>(false);

    return (
        <CloudFileDashboardContext.Provider
            value={{
                cloudFileId,

                selectedVersionInfo,
                setSelectedVersionInfo,

                lookupFileRecordId,
                setLookupFileRecordId,

                areUnsavedChanges,
                setAreUnsavedChanges,

                isInactiveContentSelected,
                setIsInactiveContentSelected,

                isAssociateFormReady,
                setIsAssociateFormReady
            }}
        >
            {children}
        </CloudFileDashboardContext.Provider>
    );
};
